import initialState from './initialState';
import {
  FETCH_DASHBOARD_INIT,
  FETCH_DASHBOARD_SUCCESS,
  FETCH_DASHBOARD_FAILURE,
  FETCH_DASHBOARD_DATE_INIT,
  FETCH_DASHBOARD_DATE_SUCCESS,
  FETCH_DASHBOARD_DATE_FAILURE,
  FETCH_TASK_MANAGER_INDICATORS_INIT,
  FETCH_TASK_MANAGER_INDICATORS_SUCCESS,
  FETCH_TASK_MANAGER_INDICATORS_FAILURE,
  DASHBOARD_CHANGE_MENU_COLLAPSE_STATE,
  RESET_DASHBOARD,
  CHANGE_LANGUAGE,
  BEHAVIOR_CONFIG,  
  SET_TOUR_VIEWED_SUCCESS
} from '../../actions/dashboard/types';
import Constants from '../../containers/function/constants.js';
import Cookies from 'universal-cookie';
import { saveLocalState, deleteLocalState, localStoreFN } from '../../store/localStorage.js';
const cookies = new Cookies();

export default function dashboard(state = initialState, action) {
  switch (action.type) {
    /* Setting */
    case FETCH_DASHBOARD_INIT:
      var collapseMenuCookie = cookies.get("collapse_menu");
      var collapseMenuObject = collapseMenuCookie ? collapseMenuCookie : {};
      var userId = localStoreFN().getItem('userId');
      var menuCollapse = false;
      if(userId) {
        menuCollapse = collapseMenuObject[userId];
      }
      return {
        ...state,
        setting: null,
        loading: true,
        error: null,
        menuCollapse: menuCollapse
      };
    case FETCH_DASHBOARD_SUCCESS:
      return {
        ...state,
        setting: action.payload.data ? action.payload.data : false,
        error: null,
        loading: false,
        status: action.payload.status
      };
    case FETCH_DASHBOARD_FAILURE:
      return {
        ...state,
        setting: false,
        error: action.payload,
        loading: false
      };

    /* Date */
    case FETCH_DASHBOARD_DATE_INIT:
      return {
        ...state,
        dateMax: [],
        loadingDate: true,
        error: null
      };
    case FETCH_DASHBOARD_DATE_SUCCESS:
      return {
        ...state,
        dateMax: action.payload.data,
        error: null,
        loadingDate: false,
        statusDate: action.payload.status
      };
    case FETCH_DASHBOARD_DATE_FAILURE:
      return {
        ...state,
        dateMax: [],
        error: action.payload,
        loadingDate: false,
        status: 401
      };
    case FETCH_TASK_MANAGER_INDICATORS_INIT:
      return {
        ...state,
        taskManagerIndicators: {
          ...state.taskManagerIndicators,
          loading: true
        }
      };
    case FETCH_TASK_MANAGER_INDICATORS_SUCCESS:
      return {
        ...state,
        taskManagerIndicators: {
          ...state.taskManagerIndicators,
          data: action.payload.data,
          loading: false,
          status: action.payload.status
        }
      };
    case FETCH_TASK_MANAGER_INDICATORS_FAILURE:
      return {
        ...state,
        taskManagerIndicators: {
          ...state.taskManagerIndicators,
          data: null,
          loading: false,
          status: 500
        }
      };
    /* Change language */
    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.payload,
        loadingLanguage: false
      };
    case DASHBOARD_CHANGE_MENU_COLLAPSE_STATE:
      var collapseMenuCookie = cookies.get("collapse_menu");
      var collapseMenuObject = collapseMenuCookie ? collapseMenuCookie : {};
      var userId = localStoreFN().getItem('userId');
      if(userId) {
        collapseMenuObject[userId] = !state.menuCollapse;
        cookies.set("collapse_menu", collapseMenuObject);
      }
      return {
        ...state,
        menuCollapse: !state.menuCollapse
      };
    case RESET_DASHBOARD:
      return {
        ...state,
        setting: null,
        loading: true,
        loadingDate: true,
        error: null,
        menuCollapse: false,
        dateMax: []
      };
    case SET_TOUR_VIEWED_SUCCESS:
      var viewedToursObject = {}
      
      for(var tour in Constants.toursKeys) {
        viewedToursObject[Constants.toursKeys[tour]] = false;
      }

      if(action.payload.data.tours) {
        for(var i=0;i<action.payload.data.tours.length;i++) {
          viewedToursObject[action.payload.data.tours[i]] = true;
        }
      }
      
      saveLocalState({key:'viewedTours', value: JSON.stringify(viewedToursObject)});
      return {
        ...state
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/dashboard/index.js